// react-router components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Config
import { promo } from "config/promo";

/**
 * Full-width announcement strip for the seasonal free-van offer. Sits above the
 * navbar so it's the first thing visitors see, and the whole bar links to the
 * dedicated offer page. Renders nothing when the promo is switched off.
 */
function PromoBanner() {
  if (!promo.active) return null;

  return (
    <MKBox
      component={Link}
      to={promo.ctaPath}
      variant="gradient"
      bgColor="warning"
      py={1.2}
      px={2}
      sx={{
        display: "block",
        textDecoration: "none",
        transition: "filter 0.2s ease",
        "&:hover": { filter: "brightness(0.95)" },
      }}
    >
      <Container>
        <MKBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          gap={{ xs: 0.5, md: 1.5 }}
          textAlign="center"
        >
          <Icon sx={{ color: "#fff", fontSize: "1.2rem !important" }}>local_offer</Icon>
          <MKTypography variant="button" fontWeight="bold" sx={{ color: "#fff" }}>
            {promo.bannerText}
          </MKTypography>
          <MKTypography
            variant="button"
            fontWeight="bold"
            sx={{
              color: "#fff",
              textDecoration: "underline",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            See details
            <Icon sx={{ ml: 0.3, fontSize: "1rem !important" }}>arrow_forward</Icon>
          </MKTypography>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default PromoBanner;
